import { render, staticRenderFns } from "./sidemenu_suggest_influencer.vue?vue&type=template&id=b52577be&"
import script from "./sidemenu_suggest_influencer.vue?vue&type=script&lang=js&"
export * from "./sidemenu_suggest_influencer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports